import { ORDERS_STATS_EVENTS } from './global-events';

export const ordersSlideMenuItems = [
  {
    name: 'Продажі  ₴',
    event: ORDERS_STATS_EVENTS.ORDERS_STATS_AMOUNT,
  },
  {
    name: 'Продажі ШТ',
    event: ORDERS_STATS_EVENTS.ORDERS_STATS_COUNT,
  },
  {
    name: 'Комісійні винагороди',
    event: ORDERS_STATS_EVENTS.ORDERS_STATS_EARNINGS,
  },
];
